<style lang="scss">
.services-page {
    .page-title {
        color: #ff5b94;
        font-size: 30px;
        font-weight: 600;
        text-transform: uppercase;
    }
    .page-title-wrapper {
        position: relative;
        .display-icon {
            font-size: 16px;
            color: #c8c8c8;
            padding: 5px;
            cursor: pointer;
            &.active {
                color: #595e63;
            }
        }
    }

    .top-dividers-container {
        padding: 0;
        .top-divider-wrapper {
            padding: 0;
        }
        .top-divider {
            width: 90%;
            border-bottom: 1px solid #e6e6e6;
            margin: auto;
        }
    }

    .service-container {
        margin-bottom: 20px;
    }


    @media (max-width: 550px) {
        .page-title {
            font-size: 26px;
        }
    }

    @media (max-width: 360px) {
        .service-container {
            width: 100%;
        }
    }
}
.infinity-loading {
    width: 100px;
    height: 100px;
}
</style>

<template>
    <div class="services-page padding">
        <div class="page-title-wrapper tw-flex tw-items-center tw-justify-between tw-mb-6">
            <h1 v-if="page" class="page-title tw-mb-0" :style="$highlightColor">{{page.name}}</h1>
            <div class="display-icons tw-whitespace-nowrap">
                <span class="block-display-icon display-icon" :style="$iconColorStyle(this.display == 'block')" @click="changeDisplay('block')"><font-awesome-icon icon="th"></font-awesome-icon></span>
                <span class="list-display-icon display-icon" :style="$iconColorStyle(this.display == 'list')" @click="changeDisplay('list')"><font-awesome-icon icon="list"></font-awesome-icon></span>
            </div>
        </div>

        <div class="tw-py-2" v-if="beatTapes.length == 0 && complete">
            No beat tapes found.
        </div>

        <div v-else class="row">
            <template v-if="display == 'list'">
                <row-beat-tape-container :parent="getBeatTapesPageName" v-for="beatTape in beatTapes" :key="beatTape.id" :beat-tape="beatTape"></row-beat-tape-container>
            </template>
            <template v-else>
                <div class="tw-mb-2 md:tw-mb-4 lg:tw-mb-5 col-xs-6 col-md-3" v-for="beatTape in beatTapes" :key="beatTape.id">
                    <beat-tape-container :beatTape="beatTape"></beat-tape-container>
                </div>
            </template>
        </div>
        <infinite-loading @infinite="loadMore" class="tw-mt-4" ref="infiniteLoading" :distance="500">
            <span slot="spinner">
                <img src="https://i.imgur.com/YB4fJJk.gif" class="infinity-loading">
            </span>
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
    </div>
</template>

<script>
import BeatTapeContainer from '../beat-tapes/list/beat-tape-container.vue'
import RowBeatTapeContainer from '../beat-tapes/list/beat-tape-row-container.vue'
import InfiniteLoading from 'vue-infinite-loading'
import Configure from './../../mixins/configure'
import BeatTapes from "../../models/beat-tapes";
import BeatTapesRepository from './../../mixins/beat-tapes-repository'

export default {
    props: ['pageId'],
    components: {
        BeatTapeContainer, RowBeatTapeContainer, InfiniteLoading
    },
    data() {
        return {
            initialLoad: true,
            beatTapesPage: 0,
            beatTapes: [],
            filtering: false,
            filter: {},
            complete: false,
            infiniteLoadingState: null,
            display: 'block'
        }
    },
    computed: {
        getCurrentPage() {
          return this.page
        },
        getBeatTapesPageName(){
            let pageName = {name:null, type:null};
            this.config.pagesConfig.forEach((e) => {
                if( e.type === "beattapes" ) {
                    pageName.name = e.link.substring(1);
                    pageName.type = e.type;
                }
            });
            return pageName;
        },
        user() {
            return this.$store.state.user
        },
        config() {
            return this.$store.state.currentConfig
        },
        page() {
            if (this.pageId) {
                let page = this.config.getPageById(this.pageId)
                this.$store.commit("currentPage", {page: page})

                return page
            }
        },
    },
    mixins: [BeatTapesRepository, Configure],
    methods: {
        onFilterChange(filter) {
            if (this.initialLoad) {
                return
            }
            this.complete = false
            this.beatTapes = []
            this.beatTapesPage = 0
            this.filtering = true
            this.filter = filter
            this.infiniteLoadingState.reset()
        },
        async getBeatTapes(page) {
            try {
                const selection = this.page.display_selection && this.page.display_selection_list
                if (!selection) {
                    this.clear()
                    const response = await this.getUserBeatTapes(page, 20, {
                        selection
                    })
                    let beatTapes = BeatTapes.makeArray(response.data.items)
                    this.beatTapes.push(...beatTapes)
                    this.infiniteLoadingState.complete()
                    this.complete = true
                    this.$nextTick(() => {
                        if (this.infiniteLoadingState) {
                            this.infiniteLoadingState.complete()
                            this.complete = true
                        }
                    })
                } else {
                    const response = await this.getAllSelectedItems(selection)
                    let beatTapes = BeatTapes.makeArray(response.data.items)
                    this.beatTapes.push(...beatTapes)
                    this.infiniteLoadingState.complete()
                    this.complete = true
                }
            } catch (error) {
                this.complete = true
                if (this.infiniteLoadingState) {
                    this.infiniteLoadingState.complete()
                }
            } finally {
                this.filtering = false
                this.initialLoad = false
            }
        },
        loadMore($state) {
            this.infiniteLoadingState = $state

            this.beatTapesPage++
            this.getBeatTapes(this.beatTapesPage)
        },
        clear() {
            this.complete = false
            this.beatTapes = []
            this.beatTapesPage = 0
            this.filtering = false
        },
        reload() {
            this.clear()
            this.infiniteLoadingState.reset()
        },
        changeDisplay (display) {
            this.display = display
        }
    },
    watch: {
        'page.display_selection'() {
            this.reload()
        },
        'page.display_selection_list'() {
            this.reload()
        },
        'page.display_music': {
            handler(val) {
                if (val == "block" || val == "list") {
                    this.display = val
                }
            },
            immediate: true
        }
    }
}

</script>
